import { inject, Pipe, type PipeTransform } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { City } from 'src/app/interface/city';
import { AddressService } from 'src/app/service/address.service';
import { ObjectId } from 't5-common';

@Pipe({
  name: 'mkgFindCity',
  standalone: true,
  pure: true
})
export class FindCityPipe implements PipeTransform {

  private _addressService = inject(AddressService);
  private _cityCache = new Map<ObjectId, City>();

  transform(id: ObjectId): Observable<City> {
    if(!id){
      return of(null);
    }
    let city = this._cityCache.get(id);
    if(!city){
      return this._addressService.getCity(id).pipe(
        tap(city => this._cityCache.set(id, city)),
        shareReplay(1)
      );
    }

    return of(city);
  }

}
